<template>

    <div class="mb-3" :class="{'form-floating': floating}">

        <label v-if="label && floating === false" class="form-label" :for="id">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <input 
            :id="id" 
            ref="input"
            v-bind="$attrs"
            class="form-control" 
            :class="{ 'is-invalid': error }" 
            :placeholder="floating && !placeholder ? translatedLabel : placeholder" 
            :type="type"
            :value="value" 
            @input="$emit('input', $event.target.value)" />

        <label v-if="label && floating" class="form-label" :for="id">
            {{ translatedLabel }}
        </label>

        <div v-if="error" class="invalid-feedback">{{ error }}</div>

    </div>

</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `text-input-${this._uid}`
                },
            },
            type: {
                type: String,
                default: 'text',
            },
            value: {
                default: '',
            },
            placeholder: {
                default: '',
            },
            floating: {
                default: false,
            },
            label: String,
            error: String,
            help: String,

        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            },
            select() {
                this.$refs.input.select()
            },
            setSelectionRange(start, end) {
                this.$refs.input.setSelectionRange(start, end)
            },
        },
    }
</script>